const o=100,t=50;export{t as DEFAULT_THROTTLE_RATE,o as EVENT_END_DELAY};
//# sourceMappingURL=constants.js.map
